import { noop } from 'lodash-es';
import { put, call, takeLatest } from 'redux-saga/effects';
import { setError } from '../../reducers/error';
import { setLoader } from '../../reducers/loader';
import { setActionLoaderFalse, setActionLoaderTrue } from '../../reducers/actionLoader';
import { getIndianIndicesToken } from '../../../utils/equity/indices';
import { fetchScripDetailList } from '../../reducers/equity/guestLogin';
import { fetch_global_indices_v2, fetch_indian_indices_v2 } from '../../../apis/equity/sessionLess/indices';
import { fetchGlobalIndices, fetchIndianIndices, setGlobalIndices, setIndianIndices } from '../../reducers/equity/indices';
export default function* indicesSagaV2() {
	yield takeLatest(fetchGlobalIndices.toString(), handleFetchGlobalIndices);
	yield takeLatest(fetchIndianIndices.toString(), handleFetchIndianIndices);
}

function* handleFetchGlobalIndices({ payload = {} }) {
	const { screen = '', sagaCallback = noop, Api, sessionLessServer = ''} = payload;
	try {
		yield put(setActionLoaderTrue(fetchGlobalIndices));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(fetch_global_indices_v2, Api, sessionLessServer);
		yield put(setGlobalIndices(response.data));
		yield put(setLoader({ screen, isFetchingGlobalIndices: false }));
		yield call(sagaCallback, response.data);
	} catch (err) {
		console.log('error in handleFetchGlobalIndices', err.message);
		yield put(setError({ isFetchFailed: true, screen, message: err.message }));
	} finally {
		yield put(setActionLoaderFalse(fetchGlobalIndices));
	}
}
function* handleFetchIndianIndices({ payload = {} }) {
	const { screen = '', sagaCallback = noop, Api, sessionLessServer = '', isGuestApiAllowed = false } = payload;
	try {
		yield put(setActionLoaderTrue(fetchIndianIndices));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(fetch_indian_indices_v2, Api, sessionLessServer);

		yield put(setIndianIndices(response.data));
		yield put(setLoader({ screen, isFetchingIndianIndices: false }));
		if (isGuestApiAllowed) {
			const indicesTokenList = getIndianIndicesToken(response.data);
			yield put(
				fetchScripDetailList({
					scripTokenList: indicesTokenList,
					screen: '',
					isGuestApiAllowed: true,
				}),
			);
		}
		yield call(sagaCallback, response);
	} catch (err) {
		console.log('error in handleFetchIndianIndices', err.message);
		yield put(setError({ isFetchFailed: true, screen, message: err.message }));
	} finally {
		yield put(setActionLoaderFalse(fetchIndianIndices));
	}
}
